export function truncateHTML(htmlString, maxChars) {
    const container = document.createElement('div');
    container.innerHTML = htmlString;

    let count = 0;
    function walk(node) {
        // wenn Limit erreicht, nichts mehr hinzufügen
        if (count >= maxChars) return null;

        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            if (count + text.length > maxChars) {
                const slice = text.slice(0, maxChars - count);
                count = maxChars;
                return document.createTextNode(slice);
            } else {
                count += text.length;
                return document.createTextNode(text);
            }
        }

        if (node.nodeType === Node.ELEMENT_NODE) {
            const clone = node.cloneNode();
            clone.innerHTML = ''; // leeren
            for (let child of node.childNodes) {
                const truncatedChild = walk(child);
                if (truncatedChild) clone.appendChild(truncatedChild);
                if (count >= maxChars) break;
            }
            return clone;
        }

        return null;
    }

    const frag = document.createDocumentFragment();
    for (let child of container.childNodes) {
        const truncated = walk(child);
        if (truncated) frag.appendChild(truncated);
        if (count >= maxChars) break;
    }

    const wrapper = document.createElement('div');
    wrapper.appendChild(frag);
    return wrapper.innerHTML + (count >= maxChars ? '…' : '');
}
